import { NavLink, useNavigate } from "react-router-dom";
import {
  MdDashboard, MdReport, MdListAlt, MdPerson, MdLogout,
  MdNotifications, MdCardMembership, MdHistory, MdUpload,
} from "react-icons/md";
import useAlertCount from "../../utils/useAlertCount";

const Sidebar = ({ onClose, planFeatures = {} }) => {
  const navigate = useNavigate();
  const canReceiveAlerts = planFeatures.canReceiveAlerts !== false;
  const { unreadCount } = useAlertCount(canReceiveAlerts);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("ownerRole");
    navigate("/");
  };

  const handleNav = () => {
    if (onClose) onClose();
  };

  return (
    <>
      <h3 className="logo">🚗 FraudCheck</h3>
      <nav>
        <NavLink to="/owner/dashboard" onClick={handleNav} className={({ isActive }) => isActive ? "active" : ""}>
          <MdDashboard className="icon" /> Dashboard
        </NavLink>

        <NavLink to="/owner/report-fraud" onClick={handleNav} className={({ isActive }) => isActive ? "active" : ""}>
          <MdReport className="icon" /> Report Fraud
        </NavLink>

        <NavLink to="/owner/registered-frauds" onClick={handleNav} className={({ isActive }) => isActive ? "active" : ""}>
          <MdListAlt className="icon" /> My Reports
        </NavLink>

        {planFeatures.canBulkImport === true && (
          <NavLink to="/owner/bulk-import" onClick={handleNav} className={({ isActive }) => isActive ? "active" : ""}>
            <MdUpload className="icon" /> Bulk Import
          </NavLink>
        )}

        {canReceiveAlerts && <NavLink to="/owner/notifications" onClick={handleNav}
          className={({ isActive }) => isActive ? "active" : ""}
          style={{ position: "relative" }}>
          <MdNotifications className="icon" /> Notifications
          {unreadCount > 0 && (
            <span style={{
              position: "absolute", top: "6px", right: "12px",
              background: "#ef4444", color: "#fff",
              fontSize: "10px", fontWeight: "700",
              borderRadius: "10px", padding: "1px 6px",
              minWidth: "18px", textAlign: "center", lineHeight: "16px",
            }}>
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </NavLink>}

        <NavLink to="/owner/subscription" onClick={handleNav} className={({ isActive }) => isActive ? "active" : ""}>
          <MdCardMembership className="icon" /> Subscription
        </NavLink>

        {/* ── Activity Logs ── */}
        <NavLink to="/owner/logs" onClick={handleNav} className={({ isActive }) => isActive ? "active" : ""}>
          <MdHistory className="icon" /> Activity Logs
        </NavLink>

        <NavLink to="/owner/profile" onClick={handleNav} className={({ isActive }) => isActive ? "active" : ""}>
          <MdPerson className="icon" /> Profile
        </NavLink>

        <button className="sidebar-logout-btn" onClick={handleLogout} style={{
          display: "flex", alignItems: "center", gap: "12px",
          padding: "10px 16px", width: "100%", border: "none",
          background: "none", color: "#a3aed0", fontSize: "14px",
          fontWeight: "500", cursor: "pointer", borderRadius: "12px",
          marginTop: "8px",
        }}>
          <MdLogout className="icon" style={{ fontSize: "18px" }} /> Sign Out
        </button>
      </nav>
    </>
  );
};

export default Sidebar;